import { useState } from "react";
// import { Button } from "@/components/ui/button";
// import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
// import heroBg from "@/assets/hero-bg.jpg";
import { getNewsListUser } from "context/actions/news";

const HeroSection = ({ covers }) => {
  const [trackingNumber, setTrackingNumber] = useState("");
  const [data, setData] = useState([]);
  const [check, setCheck] = useState(0);

  const heroImage =
    covers?.[0]?.image?.thumbnail ||
    covers?.[0]?.image?.path ||
    "hero-cargo.jpg";
  const getInitData = async () => {
    try {
      const res = await getNewsListUser(trackingNumber, 1);
      if (res.status === "success") setData(res.data.data || []);
      else setData([]);
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
    }
  };

  const handleTrack = async () => {
    if (!trackingNumber.trim()) {
      alert("Трак кодоо оруулна уу");
      return;
    }
    await getInitData();
    setCheck(1);
  };

  return (
    <section
      className="relative min-h-[600px] flex items-center justify-center pt-16"
      style={{
        backgroundImage: `url(${heroImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-hero-gradient" />

      <div className="container mx-auto px-4 relative z-10 py-20">
        <div className="max-w-3xl mx-auto ">
          <h1 className=" text-center text-4xl md:text-5xl lg:text-6xl font-bold text-primary-foreground mb-6 animate-fade-in">
            Хятадаас Монгол руу{" "}
            <span className="text-accent">хурдан хүргэлт</span>
          </h1>
          <p
            className="text-lg md:text-xl text-primary-foreground/90 mb-10 animate-fade-in"
            style={{ animationDelay: "0.2s" }}
          >
            Найдвартай, шуурхай карго үйлчилгээ. Таны илгээмжийг аюулгүй
            хүргэнэ.
          </p>

          {/* Search Card */}
          <div
            className="bg-card/95 backdrop-blur-sm rounded-2xl p-6 shadow-elevated max-w-xl mx-auto animate-fade-in"
            style={{ animationDelay: "0.4s" }}
          >
            <label className="block text-sm font-medium text-muted-foreground mb-2">
            Трак кодоо оруулж шалгана уу.
            </label>
            <div className="flex gap-3">
              <input
                type="text"
                placeholder=""
                value={trackingNumber}
                onChange={(e) => setTrackingNumber(e.target.value)}
                className="input-field flex-1"
              />
              <button
                onClick={handleTrack}
                className="btn-accent bg-accent p-4  rounded-lg flex items-center gap-2"
              >
                <Search className="w-5 h-5" />
                <span className="hidden sm:inline font-bold text-lg">Илгээмж шалгах</span>
              </button>
            </div>

            <div className="mt-3 text-sm text-muted-foreground">
              Утасны дугаараараа ачаагаа шалгах бол{" "}
              <a
                href="/track"
                className="text-accent font-semibold hover:underline"
              >
                нэвтэрнэ үү →
              </a>
            </div>

            {/* Results */}
            {check === 1 && (
              <>
                {data.length > 0 ? (
                  <div className="mt-6 space-y-4">
                    {data.map((item, index) => (
                      <div
                        key={index}
                        className="p-4 rounded-lg shadow-sm border border-border bg-white transition hover:shadow-md"
                      >
                        <h3 className="text-lg font-semibold text-foreground mb-1">
                          {item.name}
                        </h3>
                        <div className="flex flex-col font-semibold sm:flex-row sm:justify-between gap-2 text-sm text-muted-foreground">
                          <span>📞 Утас: {item.phone}</span>
                          <span>
                            📍 Байршил:{" "}
                            {item.location === "Монголд"
                              ? item.branchName
                              : item.location}
                          </span>
                          <span>💰 Үнэ: {item.price}₮</span>
                        </div>
                      </div>
                    ))}

                    {/* Total & Discount */}
                    {/* <div className="mt-4 p-4 rounded-lg bg-gray-50 text-center font-semibold text-base text-foreground shadow-sm">
                      {(() => {
                        const totalPrice = data.reduce(
                          (sum, i) => sum + Number(i.price || 0),
                          0
                        );
                        const discountRate = totalPrice >= 100_000 ? 0.05 : 0;
                        const discount = totalPrice * discountRate;
                        const payable = totalPrice - discount;
                        const formatMoney = (n) =>
                          n.toLocaleString("en-US", {
                            maximumFractionDigits: 0,
                          });

                        return totalPrice >= 100_000 ? (
                          <>
                            🧾 Нийт үнэ: {formatMoney(totalPrice)}₮ <br />
                            💸 Хөнгөлөлт {discountRate * 100}%:{" "}
                            {formatMoney(discount)}₮ <br />→ Эцсийн төлбөр:{" "}
                            {formatMoney(payable)}₮
                          </>
                        ) : (
                          <span>🧾 Нийт үнэ: {formatMoney(totalPrice)}₮</span>
                        );
                      })()}
                    </div> */}
                  </div>
                ) : (
                  <div className="mt-4 text-sm text-muted-foreground">
                    Илгээмж олдсонгүй.
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* Wave Decoration */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg
          viewBox="0 0 1440 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full"
        >
          <path
            d="M0 50L48 45.8333C96 41.6667 192 33.3333 288 29.1667C384 25 480 25 576 33.3333C672 41.6667 768 58.3333 864 62.5C960 66.6667 1056 58.3333 1152 50C1248 41.6667 1344 33.3333 1392 29.1667L1440 25V100H1392C1344 100 1248 100 1152 100C1056 100 960 100 864 100C768 100 672 100 576 100C480 100 384 100 288 100C192 100 96 100 48 100H0V50Z"
            fill="hsl(var(--background))"
          />
        </svg>
      </div>
    </section>
  );
};

export default HeroSection;
